import { View, Text, BackHandler, StyleSheet } from "react-native";
import React, { useCallback, useEffect, useState } from "react";
import { useFocusEffect, useNavigation } from "@react-navigation/native";

import { PROFILE_ROUTES } from "../../../../navigation/routes";
import BottomView from "../../../../components/GlobalComponents/BottomView";
import TextView from "../../../../components/CustomComponent/TextView";
import GlobalStyles from "../../../../globalStyles/globalStyles";
import TopIconView from "../../../Auth/components/TopIconView";
import ProfileIcons from "../../../../assets/Icons/FeedIcons/ProfileIcons";
import AgeModal from "../../../../modal/OnBoardingModal/AgeModal";
import RNPickerSelect from "react-native-picker-select";
import { RootState, useSelector } from "../../../../redux/store";
import CustomComponent from "../../../../components/CustomComponent";
import { Colors } from "../../../../globalStyles/ColorConfig";


export default function BasicInfo_DateOfBirthWeb() {
  const navigation = useNavigation();
  const [age, setAge] = useState(0);
  const [isModalVisible, setModalVisible] = useState(false);
  const [selectedDay, setSelectedDay] = useState<string | undefined>(undefined);
  const [selectedMonth, setSelectedMonth] = useState<string | undefined>(
    undefined
  );
  const [selectedYear, setSelectedYear] = useState<string | undefined>(
    undefined
  );
  const [isDOBError, setIsDOBError] = useState(false);
  const [DobErrorText, setDobErrorText] = useState('')

  function calculateAge(dateOfBirth: string): number {
    const [year, month, day] = dateOfBirth.split("-").map(Number);
    const dob = new Date(year, month - 1, day); // Note: Months are zero-based in JavaScript

    const now = new Date();

    let age = now.getFullYear() - dob.getFullYear();
    const hasBirthdayOccurred =
      now.getMonth() > dob.getMonth() ||
      (now.getMonth() === dob.getMonth() && now.getDate() >= dob.getDate());

    if (!hasBirthdayOccurred) {
      age--;
    }

    return age;
  }
  const toggleModal = () => {
    if(!selectedDay || !selectedMonth || !selectedYear){
      setDobErrorText("Please Select you DOB")
      setIsDOBError(true)
    }
    const dob = `${selectedYear}-${selectedMonth}-${selectedDay}`;
    const age = calculateAge(dob)
    if(age < 18){
      setDobErrorText('Age should be 18 or above')
      setIsDOBError(true)
      return
    }
    setAge(age);
    if(selectedDay && selectedMonth && selectedYear && !isDOBError){
      setModalVisible(!isModalVisible);
    }
  };

  const days = Array.from({ length: 31 }, (_, i) =>
    (i + 1).toString().padStart(2, "0")
  );
  const months = Array.from({ length: 12 }, (_, i) =>
    (i + 1).toString().padStart(2, "0")
  );
  // const years = Array.from({ length: 50 }, (_, i) => (2000 + i).toString());
  // make years from 1910 to 2024
  const years = Array.from({ length: 115 }, (_, i) => (1910 + i).toString());
  const checkDate = () => {
    if (selectedDay && selectedMonth && selectedYear) {
      if (
        calculateAge(`${selectedYear}-${selectedMonth}-${selectedDay}`) < 18
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  };


  const renderErrorMessage = () => {
    if (isDOBError) {
      return (
        <CustomComponent.TextView
          title={DobErrorText}
          textStyle={[GlobalStyles.bodyText, { color: Colors.red10, marginVertical: 10 }]}
        />
      );
    }
    return null;
  };

  useEffect(()=> {
    setIsDOBError(false)
  },[selectedDay, selectedMonth, selectedYear])

  return (
    <View
      style={{
        flex: 1,
        backgroundColor: "#ffffff",
        paddingTop: 30,
      }}
    >
      <AgeModal
        isVisible={isModalVisible}
        toggleModal={toggleModal}
        age={age}
        dob={[selectedDay, selectedMonth, selectedYear]}
      />
      <View
        style={{
          flex: 1,
          paddingHorizontal: 25,
          gap: 16
        }}
      >
        
        {/* <View style={{display:'flex',width:'100%',justifyContent:'center',alignItems:'center'}}>
                <TopIconView
                icon={<ProfileIcons.BirthdayIcon />}
                currentScreen={2}
                totalScreens={10}
              /></View> */}
        <View style={{width:'100%',justifyContent:'center',alignItems:'center', flexDirection: 'row'}}>
                <TopIconView
                  icon={<ProfileIcons.BirthdayIcon/>}
                  currentScreen={2}
                  totalScreens={10}
                />
              </View>
        <View>
          <TextView
            title="What's your date of birth?"
            textStyle={GlobalStyles.heading3}
          />
          <View
            style={{
              flexDirection: "row",
              gap: 10,
              marginTop: 10,

              alignItems: "flex-start",
            }}
          >
            <RNPickerSelect
              
              style={{
                inputWeb: {
                  backgroundColor: "#F3F1EF",
                  borderRadius: 8,
                  width: "100%",
                  borderWidth: 0,
                  height: 40,
                  textAlign: "center",
                  color: "#000000",
                  paddingHorizontal: 10
                },
              }}
              placeholder={{ label: "DD", value: "" }}
              value={selectedDay}
              onValueChange={(value) => setSelectedDay(value)}
              items={days.map((day) => ({
                label: day,
                value: day,
                color: "#000000",
              }))}
            />
            <RNPickerSelect
              style={{
                inputWeb: {
                  backgroundColor: "#F3F1EF",
                  borderRadius: 8,
                  width: "100%",
                  borderWidth: 0,

                  height: 40,
                  textAlign: "center",
                  color: "#000000",
                  paddingHorizontal: 10
                },
              }}
              placeholder={{ label: "MM", value: "" }}
              value={selectedMonth}
              onValueChange={(value) => setSelectedMonth(value)}
              items={months.map((month) => ({
                label: month,
                value: month,
                color: "#000000",
              }))}
            />

            <RNPickerSelect
              style={{
                inputWeb: {
                  backgroundColor: "#F3F1EF",
                  borderRadius: 8,
                  width: "100%",
                  borderWidth: 0,
                  paddingHorizontal: 10,
                  height: 40,
                  textAlign: "center",
                  color: "#000000",
                },
              }}
              placeholder={{ label: "YYYY", value: "" }}
              value={selectedYear}
              onValueChange={(value) => setSelectedYear(value)}
              items={years.map((year) => ({
                label: year,
                value: year,
                color: "#000000",
              }))}
            />
          </View>
          {renderErrorMessage()}
        </View>  
      </View>
      <BottomView
        enableTitle={true}
        onPress={toggleModal}
        disableBtn={true}
        bottomTitle="We use this to calculate the age on your profile"
        bottomTitleIcon={false}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  input: {
    backgroundColor: "#F0EEEC",
    width: 60,
    height: 50,
    marginHorizontal: 5, // Adjust as needed
    textAlign: "center",
    borderRadius: 8,
  },
});
